<template>
  <div
    class="card flex items-center mb-5 space-x-5"
  >
    <div class="w-14 shrink-0">
      <img
        src="/img/icons/svg/windmill.svg"
        alt="Windmill"
        class="w-full"
      >
    </div>
    <div>
      <h2 class="mb-2 text-lg leading-snug text-gray-600">
        You have offset <b class="text-gray-900">{{ achievements.total_offset }}&nbsp;Tons&nbsp;Of&nbsp;Carbon</b>.
      </h2>
      <a
        v-if="showLink"
        class="btn btn-primary w-full mt-3 text-xs"
        href="https://carbonii.com/"
        target="_blank"
      >
        <span>
          See the projects we support
          <i class="mdi mdi-open-in-new" />
        </span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "v-achievements-offset",
  props: {
    achievements: {
      type: Object,
      required: true
    },
    showLink: {
      type: Boolean,
      default: true
    }
  }
};
</script>
